import React, { FC } from 'react'

import { useDuplicateShare } from 'modules/shares/hooks/useDuplicateShare'
import { useResponsiveDropdown } from '@sketch/components'
import { useVersioning } from 'modules/versioning'

import { ShareActionsDropdown } from '../ShareActionsDropdown'
import { DotsIcon, SettingsButton } from './DocumentSettingsDropdown.styles'
import { VersioningContextReady } from 'modules/versioning/ShareVersionContext/ShareVersionContext'

export const DocumentSettingsDropdown: FC = () => {
  const {
    share,
    versionShortId,
    latestVersionId,
    isViewingLatestVersion,
    currentVersion = { identifier: '' },
  } = useVersioning() as VersioningContextReady

  const versions = {
    current: { shortId: versionShortId },
    latest: { shortId: latestVersionId },
  }

  const workspaceIdentifier = share.workspace.identifier

  const [duplicateShare] = useDuplicateShare({
    share,
    versionIdentifier: currentVersion.identifier,
    workspaceIdentifier,
  })

  const [dropdown, buttonProps] = useResponsiveDropdown({
    dropdown: ShareActionsDropdown,
    dropdownProps: {
      share,
      versions,
      isViewingLatestVersion,
      workspaceIdentifier,
      onDuplicateShareClick: duplicateShare,
    },
    placement: 'bottom-end',
  })

  return (
    <>
      <SettingsButton data-testid="document-settings-toggle" {...buttonProps}>
        <DotsIcon></DotsIcon>
      </SettingsButton>
      {dropdown}
    </>
  )
}

export default DocumentSettingsDropdown
